import { PagePending } from "@/components/ui/PagePending";
import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/themes")({
  pendingComponent: PagePending,
  component: lazyRouteComponent(() => import("./+Themes")),
  head: () => ({
    meta: seo({ title: "Themes" }),
  }),
});
